$(document).ready(function() {
  $('.module__slickslider').slick({
    arrows: true,
    dots: true,
	prevArrow: $('.slideshow_arrow.arrow_left'),
    nextArrow: $('.slideshow_arrow.arrow_right'),

    responsive: [
      {
        breakpoint: 1024,
        settings: {
           arrows: true,
           dots: false
        }
      }
    ]
  });


  if($('.module-image-with-text-overlay').length) {
    $(window).resize(function() {
      if(window.innerWidth >= 1024) {
        $('.module-image-with-text-overlay').find('.img').removeClass('img-mobile');
      } else {
        $('.module-image-with-text-overlay').find('.img').addClass('img-mobile');
      }
    }).resize();
  }

  if($('#AddToCart').length) {
    $('.btn-fixed.add-to-cart--secondary').click(function(e) {
      e.preventDefault();
      $('#AddToCart').trigger('click');
    });

    $(window).scroll(function() {
      const addToCartTop = $('#AddToCart').offset().top;
      const windowTop = $(window).scrollTop();
      const windowBottom = windowTop + $(window).height();


      if (addToCartTop < windowBottom && addToCartTop > windowTop) {
        $('.btn-fixed.add-to-cart--secondary').fadeOut(300);
      } else {
        $('.btn-fixed.add-to-cart--secondary').fadeIn(300);
      }
    }).scroll();

  } else if($('.btn.cart--button-checkout').length) {

    $(window).scroll(function() {
      const checkoutTop = $('.cart__row  .cart--button-checkout').offset().top;
      const windowTop = $(window).scrollTop();
      const windowBottom = windowTop + $(window).height();

      if (checkoutTop < windowBottom - $('.cart__row  .cart--button-checkout').outerHeight(true) / 2 && checkoutTop > windowTop + $('.mobile-nav-bar-wrapper').outerHeight(true)) {
        $('.btn-fixed.cart--button-checkout').fadeOut(450);
      } else {
        $('.btn-fixed.cart--button-checkout').fadeIn(450);
      }
    }).scroll();
  }

  $(window).on('load', function() {
    const target = document.querySelector('.collection-main-body-inner');
    if(target) {
      const observer = new MutationObserver(function(mutations) {
        try {
          let intervalCount = 0;

          const interval = setInterval(function() {
            if($('.pagination-loading').css('display') === 'none' || intervalCount > 20) {

                clearInterval(interval);
                setTimeout(function() {
                  const yotpoAPI = new Yotpo.API(yotpo);
                  yotpoAPI.refreshWidgets();
                },35);
            } else {
              intervalCount++;
            }
          },120);
        } catch(e) {
          console.error(e);
        }
      });
      // configuration of the observer:
      const config = { attributes: true, childList: true, characterData: true };
      // pass in the target node, as well as the observer options
      observer.observe(target, config);
    }
  });
//   $('.pagination--load-more .btn--load-more').click(function() {
//     console.log($('.pagination--load-more .btn--load-more'));
//     let intervalCount = 0;
//     const interval = setInterval(function() {
//       if($('.pagination-loading').css('display') === 'none' || intervalCount > 10) {
//         clearInterval(interval);

//       } else {
//         intervalCount++;
//       }
//     },200);

//   });

	$('a[href*="#"]').not('.product_tabs__nav a').not('.flex-next,.flex-prev').click(function() {
      if($(window).width() < 768) {
		$('html, body').animate(
			{
				scrollTop: $($.attr(this, 'href')).offset().top - 120
			},
			800
		);
      } else {

		$('html, body').animate(
			{
				scrollTop: $($.attr(this, 'href')).offset().top - 80
			},
			800
		);

      }
		return false;
	});

//   if($('.page_nav').length) {
//      const activeMenu = $('.page_nav a.active').data('module');
//      $('.grid-item').children('div').addClass('hide');
//     $('.grid-item').find(`div[data-module-id="${activeMenu}"]`).addClass('active').removeClass('hide');
//   }

//   $('.page_nav a').click(function(e) {
//     e.preventDefault();
//     const _this = $(this);
//     const data = _this.data('module');

//     $('.page_nav a').removeClass('active');
//     _this.addClass('active');

//     $('.grid-item').children().not('.module-collection--featured-collection').removeClass('active').addClass('hide');

//     $('.grid-item').find(`div[data-module-id="${data}"]`).addClass('active').removeClass('hide');
//   })


  $('.page_nav a').click(function() {
    const _this = $(this);
    $('.page_nav a').removeClass('active');
    _this.addClass('active');
  })

  if($('.prev').length) {
   $('.pagination_placeholder-left').hide();
  }
  if ($('.next').length) {
   $('.pagination_placeholder-right').hide();
  }

  if($('.product_tabs').length) {
    $('.product_tabs__nav a').first().addClass('active');
  //   console.log($('.product_tabs .tab')[0]);
    $('.product_tabs .tab')[0].classList.add("active");

  }
  $('.blog_pagination a').each(function() {
    let oldHref = $(this).attr('href');

    $(this).attr('href', oldHref + '#module-blog__pagination');
  })

  $('.product_tabs__nav a').click(function(e) {
    e.preventDefault();
    const _this = $(this);
    const data = _this.data('tab');

    $('.product_tabs__nav a').removeClass('active');
    _this.addClass('active');

    $('.product_tabs .tab').removeClass('active');
    $('.product_tabs').find(`div[data-tab="${data}"]`).addClass('active');

  })


  const homeSwiper = document.querySelectorAll('.swiper-container');


//   console.log(homeSwiper.swiper.pagination);
//   setTimeout(function() {
//     homeSwiper.swiper.pagination.destroy();
//     homeSwiper.swiper.pagination.render();
//     homeSwiper.swiper.update();
//     homeSwiper.swiper.updateSlides();
//     homeSwiper.swiper.pagination.clickable = true;
//   },2500)

  for(var i = 0; i < homeSwiper.length; i++) {
    const thisSwiper = homeSwiper[i].swiper;

    if($(homeSwiper[i]).find('.swiper-pagination-bullets').length < 2) {

      $(homeSwiper[i]).find('.swiper-pagination-bullets').hide();
//       setTimeout(function() {
//         thisSwiper.pagination.destroy();
//         thisSwiper.pagination.render();
//         thisSwiper.update();
//         thisSwiper.updateSlides();
//       },2500)
    }




  }



      // callback executed when canvas was found
//     function modifyFormat() {
// 		console.log('reviews exists');
//         $('.yotpo-display-wrapper .text-m').each(function() {
//           const reviewValue = $(this).text();

//           let formattedReviewValue = reviewValue.match(/\d/g);

//           formattedReviewValue = formattedReviewValue.join("");

//           $(this).text(`(${formattedReviewValue})`);
//         })
//     }

//     var observer = new MutationObserver(function (mutations, me) {
//       var container = $('.yotpo.bottomLine.yotpo-small .text-m');
//       if (container.length) {
//         modifyFormat();
//         me.disconnect();
//         return;
//       }
//     });

//     // start observing
//     observer.observe(document, {
//       childList: true,
//       subtree: true
//     });




	// if product reviews is empty
// 	hasReviews();

  $('.country_selector').hover(function() {
    $('.country_selector .site-nav__dropdown').addClass('show');
  }, function() {
  	$('.country_selector .site-nav__dropdown').removeClass('show');

  })



//   On scroll show 'return to top arrow'
//   +
  // Logo on scroll - reduce logo size
//   $(window).scroll(function() {
//     const scrollY = window.scrollY;
//     const arrowBtn = $('.return-to-top');
//     const logo = $('.site-header__logo');
//     const nav = $('.header-section--wrapper');
//     if(scrollY > 380) {
//      logo.addClass('mini');
//       nav.addClass('scrolled');
//     } else {
//       logo.removeClass('mini');
//       nav.removeClass('scrolled');

//     }
//     if(scrollY >= 450) {
//       arrowBtn.fadeIn(300).show();
//     } else {
//       arrowBtn.fadeOut(300).hide();
//     }


//   })

  $('.return-to-top').click(function() {
    $('html,body').animate({
        scrollTop: 0
    }, 700);
  })




  $('.slick-mobile').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick"
        },
        {
            breakpoint: 520,
             settings: {
               		dots: true,
                    infinite: true,
                }
        }
    ]
  })

  $('.cta__block-items').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick"
        },
        {
            breakpoint: 520,
             settings: {
               		dots: false,
                    infinite: true,
                }
        }
    ]
  })


  if($('.homepage-slider-container').length) {
    $(window).resize(function() {
      const slideHeight = $('.homepage-slider-container .slideshow__link').outerHeight(true);
      const navHeight = $('.homepage-slider-container .image--slideshow__navigation .flex-next img').outerHeight(true);


      if($('.slideshow__link.true-arrow-pos').length !== $('.slideshow__link').length) {
        $('.homepage-slider-container .image--slideshow__navigation .flex-prev,.homepage-slider-container .image--slideshow__navigation .flex-next').css('top', `${slideHeight / 2}px`);
      }
    }).resize();

  }



})

// let counterChecker = 0;
// function hasReviews() {

//   if($('.yotpo-reviews-carousel .yotpo-carousel').length == 0) {
//     const t = setTimeout(hasReviews, 2500);
//     counterChecker++;
//     if(counterChecker == 12) {
// 		$('.module-product-reviews').hide();
//       	console.log($('.yotpo-carousel .y-slider-container'));

//      	clearTimeout(t);
// 	    return;
//     }
//   } else {
// //         $('.yotpo-carousel .y-slider-container').slick({
// //           dots: false,
// //           arrows: true,
// //           infinite: true,
// //           slidesToShow: 4,
// //           slidesToScroll: 1,
// //           prevArrow: $('.module-product-reviews .arrow_left'),
// //           nextArrow: $('.module-product-reviews .arrow_right'),
// //           responsive: [
// //             {
// //               breakpoint: 1280,
// //               settings: {
// // 	          	slidesToShow: 3
// //               }
// //             },
// //             {
// //               breakpoint: 968,
// //               settings: {
// // 	          	slidesToShow: 2
// //               }
// //             },
// //            {
// //               breakpoint: 720,
// //               settings: {
// // 	          	slidesToShow: 1
// //               }
// //             }
// //           ]
// //         })


//         $('.module-product-reviews .arrow_right').appendTo('.yotpo-reviews-carousel');
//         $('.module-product-reviews .arrow_left').prependTo('.yotpo-reviews-carousel');
//   }


// }


    function scaleToFill() {
        $(".video div").each(function (index, videoTag) {
            var $video = $(videoTag),
                //videoRatio = videoTag.videoWidth / videoTag.videoHeight,
                videoRatio = 1.7777777778,
                tagRatio = $video.width() / $video.height(),
                val;
            //console.log(videoTag.videoHeight, videoRatio, tagRatio);

            if($video.hasClass('scale-parent')) {
              videoRatio = $video.parent().width() / $video.parent().height();
            }

            if (videoRatio < tagRatio) {
                val = (tagRatio / videoRatio) * 1.02;
            } else if (tagRatio < videoRatio) {
                val = (videoRatio / tagRatio) * 1.02;
            }

            $video.css("transform", "scale(" + val + "," + val + ")");
        });
    }

    if ($(window).width() < 768) {
        $("video").on("loadedmetadata", scaleToFill);
    }


jQuery(document).ready(function ($) {

  $(window).resize(function() {
    if ($(window).width() < 768) {
      scaleToFill();
    }
  }).resize();

var logo = $('.site-header__logo');
var nav = $('.header-section--wrapper');
var header = $('.header-section');

$(document).scroll(function () {
  var arrowBtn = $('.return-to-top');

var scrollPos = $(document).scrollTop();
var windowHeight = $(window).height();
    if (scrollPos >= 360) {
        nav.addClass('scrolled');
    } else {
        nav.removeClass('scrolled');
    }
    if (scrollPos >= 450) {
        arrowBtn.fadeIn(300).show();
    } else {
        arrowBtn.fadeOut(300).hide();
    }

});
   });


